export const projSelectorConstants = {
  DISTRICT: "DISTRICT",
  UNIT: "UNIT",
  USER_ASSIGNED: "USER_ASSIGNED",
  SINGLE: "SINGLE", // Filters a single project
};
